import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

export class Consent {
    readonly necessary: Observable<boolean>;
    readonly statistics: Observable<boolean>;
    readonly marketing: Observable<boolean>;
    readonly functional: Observable<boolean>;

    constructor(necessary: Observable<boolean>, statistics: Observable<boolean>, marketing: Observable<boolean>, functional: Observable<boolean>) {
        this.necessary = necessary.pipe(shareReplay(1));
        this.statistics = statistics.pipe(shareReplay(1));
        this.marketing = marketing.pipe(shareReplay(1));
        this.functional = functional.pipe(shareReplay(1));
    }
}
